import { Link } from "react-router-dom";
import { useBrand } from "@branding/useBrand";
import { AppCta } from "../MarketingLayout";

/** FAQ page: real answers grounded in how the product actually works. */
export function Faq() {
  const brand = useBrand();

  const faqs = [
    {
      q: "Is there a free trial? Do I need a credit card?",
      a: `Yes — every plan starts with a 14-day free trial and no card is required to begin. You create your organization and start entering transactions right away.`,
    },
    {
      q: "Is there a permanent free plan?",
      a: `No. ${brand.name} is a paid product with a free trial rather than a free tier. The sample prices on the Pricing page are for illustration; no payment is collected on this website.`,
    },
    {
      q: "Does it handle UAE VAT and corporate tax?",
      a: `Yes. 5% VAT is tracked on transactions as you post them, and corporate-tax (9%) categorization tags sit on your accounts and entries so your books stay ready for the regime. ${brand.name} is a bookkeeping system — it keeps you organized and tie-out correct; it is not a substitute for advice from your tax adviser or FTA filing.`,
    },
    {
      q: "Can I run multiple entities and consolidate?",
      a: `Yes. Each Free Zone or Mainland entity keeps its own books, and you can switch to a consolidated group view. Multi-entity and consolidation are included from the Pro plan up.`,
    },
    {
      q: "How does multi-currency work?",
      a: `You post foreign-currency invoices and bills against your AED base currency, and FX gain/loss is handled automatically so multi-currency never breaks the trial-balance tie-out.`,
    },
    {
      q: "Can I import from and export to my current tool?",
      a: `Yes. CSV import and export let you run ${brand.name} alongside an existing tool and move data both ways, so you can adopt without a risky day-one migration.`,
    },
    {
      q: "Who can see my data? How is access controlled?",
      a: `Your ledger is stored on the server, scoped to your organization, and enforced server-side — only signed-in members of your organization can access it. You invite your team with owner, admin, member, and viewer roles, so you can give an external accountant read-only access without handing over control.`,
    },
    {
      q: "How is my data kept secure?",
      a: `Access is gated by authentication and role-based permissions enforced on the server, sessions use HttpOnly cookies, and a strict content-security policy limits the app to its own origin. See our Privacy Policy for how data is handled.`,
    },
    {
      q: "Is this an accredited FTA e-invoicing provider?",
      a: `Not today. ${brand.name} focuses on keeping accurate, tie-out books with VAT and corporate-tax categorization. Filing-ready VAT 201 generation and FTA-accredited e-invoicing transmission are on the roadmap, not current features — we'd rather be honest about that than imply otherwise.`,
    },
  ];

  return (
    <>
      <section className="mk-section narrow">
        <div className="mk-eyebrow">FAQ</div>
        <h1 className="mk-h1">Questions, answered honestly.</h1>
        <p className="mk-lead">
          If you don’t see your question here, start a trial and reach us from
          inside the app.
        </p>

        <div className="mk-faq">
          {faqs.map((f) => (
            <details key={f.q}>
              <summary>{f.q}</summary>
              <div className="a">{f.a}</div>
            </details>
          ))}
        </div>
      </section>

      <section className="mk-cta">
        <div className="mk-section narrow">
          <h2 className="mk-h2">Ready to see your books tie out?</h2>
          <div className="mk-hero-cta">
            <AppCta className="mk-btn primary lg">Start your free trial</AppCta>
            <Link className="mk-btn secondary lg" to="/features">
              Explore features
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
